function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3438 0.75H0.65625C0.473958 0.75 0.31901 0.813802 0.191406 0.941406C0.0638021 1.06901 0 1.22396 0 1.40625C0 1.58854 0.0638021 1.74349 0.191406 1.87109L5.25 6.92969V12.5625C5.25 12.7812 5.34115 12.9635 5.52344 13.1094L7.71094 14.6406C7.92969 14.7865 8.15755 14.7956 8.39453 14.668C8.63151 14.5586 8.75 14.3672 8.75 14.0938V6.92969L13.8086 1.87109C13.9362 1.74349 14 1.58854 14 1.40625C14 1.22396 13.9362 1.06901 13.8086 0.941406C13.681 0.813802 13.526 0.75 13.3438 0.75Z",
  fill: "currentColor"
});

var SvgFilterSolid = function SvgFilterSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFilterSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter-solid.35d6efde.svg";
export { ForwardRef as ReactComponent };